import { Skeleton } from '@mint-lib/tw-components';

const SkeletonsBox = ({
  skeletonCount,
  skeletonClassName,
  wrapperClassName,
  wrapperTestId,
  skeletonTestId,
}: {
  skeletonCount: number;
  skeletonClassName?: string;
  wrapperClassName?: string;
  wrapperTestId?: string;
  skeletonTestId?: string;
}) => {
  const skeletonIds = Array.from({ length: skeletonCount }, () =>
    crypto.randomUUID(),
  );

  return (
    <div className={wrapperClassName} data-testid={wrapperTestId}>
      {skeletonIds.map((id) => (
        <Skeleton
          key={id}
          className={skeletonClassName}
          data-testid={skeletonTestId}
        />
      ))}
    </div>
  );
};

export default SkeletonsBox;
